import { useParams, Navigate } from 'react-router-dom';
import { getToolBySlug } from '../data/toolsData';
import SEOHead from '../components/SEO/SEOHead';
import ToolHero from '../components/tool-pages/ToolHero';
import ToolBenefits from '../components/tool-pages/ToolBenefits';
import HowItWorks from '../components/tool-pages/HowItWorks';
import FeatureDetails from '../components/tool-pages/FeatureDetails';
import RelatedTools from '../components/tool-pages/RelatedTools';
import ToolFAQ from '../components/tool-pages/ToolFAQ';
import FinalCTA from '../components/tool-pages/FinalCTA';

export default function ToolPage() {
  const { slug } = useParams();
  const tool = getToolBySlug(slug);

  if (!tool) return <Navigate to="/" replace />;

  return (
    <>
      <SEOHead tool={tool} />
      <ToolHero tool={tool} />
      <ToolBenefits benefits={tool.benefits} />
      <HowItWorks steps={tool.steps} appUrl={tool.appUrl} primaryCta={tool.primaryCta} />
      <FeatureDetails tool={tool} />
      <RelatedTools currentSlug={tool.slug} />
      <ToolFAQ faqs={tool.faqs} />
      <FinalCTA tool={tool} />
    </>
  );
}
